export default "__VITE_ASSET__fveZVPjx__"